//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React from 'react';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import Button from 'src/onboarding/components/ui/button/Button';
import weighlossTransition from '../../assets/images/weightloss-support.webp';
import styles from './style.module.scss';
import { images } from 'src/onboarding/constants/images';
import getLocale from 'src/localization/get-locale';

const imageMap = {
  'weightloss-support': weighlossTransition,
  'self-awareness-start': images.self,
  'body-speaks': images.bodySpeaks,
  'motivation-heart': images.motivHeart,
  'dna-face': images.dnaFace,
  'dna-map': images.dnaMap,
};

function DynamicTransitionImageTop({ pageConfig, onNext, onPrev }) {
  const { currentIndex } = useNav();
  const locale = getLocale();

  const showPhotoProcessing = useStore((state) => state.showPhotoProcessing);

  const isFirst = currentIndex === 0;

  const imageSrc = imageMap[pageConfig.id];

  const handleContinue = () => {
    Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
      page: pageConfig.id,
    });
    onNext();
  };

  return (
    <div
      className={`page ${styles.top}`}
      style={{
        marginTop: showPhotoProcessing ? '10px' : '52px',
        gap: 0,
      }}
    >
      {!isFirst && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}

      <div
        className={styles.image}
        style={{
          backgroundImage: `url(${imageSrc})`,
        }}
      />

      <div className={'wrapper-info'} style={{ paddingBottom: 90 }}>
        <Title tag='h2'>{pageConfig.title[locale]}</Title>
        {pageConfig.text && (
          <Text semibold className={'description'}>
            {pageConfig.text[locale]}
          </Text>
        )}
        {pageConfig.subTitle && (
          <Text size='m' medium className='description'>
            {pageConfig.subTitle[locale]}
          </Text>
        )}
        <div className='overlay'></div>
      </div>

      <div className={'next-wrapper'}>
        <Button onClick={handleContinue} title={t('onboarding.analyzeBody.continue')} />
      </div>
    </div>
  );
}

export default DynamicTransitionImageTop;
